import { Link } from "react-router-dom";
import { useText } from "../context/ContentContext";

export default function Footer() {
    const tagline = useText(
        "footer_tagline",
        "Personally matching Canadians with the right real estate agent — anywhere across the country."
    );

    return (
        <footer
            className="bg-brand-sand border-t border-brand-line mt-24"
            data-testid="site-footer"
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-10 py-16">
                <div className="grid md:grid-cols-3 gap-12">
                    <div className="md:col-span-1">
                        <div className="font-serif text-2xl tracking-tight text-brand-ink mb-3">
                            Realtor<span className="italic text-brand-gold">Referral</span>
                            <span className="text-sm align-top ml-0.5">.ca</span>
                        </div>
                        <p className="text-sm text-brand-muted leading-relaxed max-w-xs">
                            {tagline}
                        </p>
                    </div>

                    <div>
                        <div className="text-xs uppercase tracking-[0.2em] text-brand-gold font-semibold mb-4">
                            Navigate
                        </div>
                        <ul className="space-y-2 text-sm">
                            {[
                                ["/", "Home"],
                                ["/about", "About"],
                                ["/faq", "FAQ"],
                                ["/journal", "Journal"],
                                ["/agents", "For Agents"],
                                ["/get-started", "Get Matched Now!"],
                            ].map(([to, label]) => (
                                <li key={to}>
                                    <Link
                                        to={to}
                                        className="text-brand-muted hover:text-brand-ink transition-colors"
                                        data-testid={`footer-link-${label.toLowerCase().replace(/\s+/g, "-")}`}
                                    >
                                        {label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <div className="text-xs uppercase tracking-[0.2em] text-brand-gold font-semibold mb-4">
                            Reach Out
                        </div>
                        <ul className="space-y-2 text-sm text-brand-muted">
                            <li>
                                <a
                                    href="mailto:hello@realtorreferral.ca"
                                    className="hover:text-brand-ink transition-colors"
                                    data-testid="footer-email-link"
                                >
                                    hello@realtorreferral.ca
                                </a>
                            </li>
                            <li>Mon – Sat, 9:00 – 19:00 ET</li>
                            <li>Serving all Canadian provinces</li>
                        </ul>
                    </div>
                </div>

                <div className="editorial-rule my-10" />

                <div
                    className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 text-xs text-brand-muted"
                    data-testid="footer-brand-line"
                >
                    <div className="flex flex-wrap gap-x-5 gap-y-2 items-center">
                        <div>© {new Date().getFullYear()} RealtorReferral.ca</div>
                        <Link to="/privacy-policy" className="hover:text-brand-ink transition-colors" data-testid="footer-privacy-link">
                            Privacy Policy
                        </Link>
                        <Link to="/terms" className="hover:text-brand-ink transition-colors" data-testid="footer-terms-link">
                            Terms of Service
                        </Link>
                        <Link to="/privacy/request" className="hover:text-brand-ink transition-colors" data-testid="footer-privacy-request-link">
                            Manage my data
                        </Link>
                        <Link to="/admin" className="hover:text-brand-ink transition-colors" data-testid="footer-admin-link">
                            Admin
                        </Link>
                    </div>
                    <div className="md:text-right">
                        <span className="text-brand-ink">Thom Gallagher</span>,
                        Sales Representative, iCloud Realty Ltd.
                    </div>
                </div>
            </div>
        </footer>
    );
}
